import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoResourceFaultPenalty } from '../interfaces/dto.resource.fault.penalty.interface';
import { IDtoResourceType } from '../interfaces/dto.resource.type.interface';
import { DtoResourceType } from './dto.resource.type';

// @dynamic
@JsonObject('DtoResourceFaultPenalty')
export class DtoResourceFaultPenalty extends ModelEntity implements IDtoResourceFaultPenalty {

    constructor(initValues: Partial<IDtoResourceFaultPenalty> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('penalty', Number, true)
    public penalty?: number = 0;

    @JsonProperty('resourceType', DtoResourceType, true)
    public resourceType?: IDtoResourceType = null;

}
